import React, { useState, useEffect } from "react";
import Layout from "./../../components/Layout";

import axios from "axios";

import moment from "moment";
import { message, Table, Popconfirm } from "antd";
import "../../styles/Appointments.css";
const DoctorAppointments = () => {
  const [appointments, setAppointments] = useState([]);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const getAppointments = async () => {
    try {
      const res = await axios.get(
        `${backendUrl}/api/v1/doctor/doctor-appointments`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.success) {
        setAppointments(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAppointments();
  }, []);

  const handleStatus = async (record, status) => {
    try {
      const res = await axios.post(
        `${backendUrl}/api/v1/doctor/update-status`,
        { appointmentId: record._id, status },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.success) {
        message.success(res.data.message);
        getAppointments();
      }
    } catch (error) {
      console.log(error);
      message.error("Something Went Wrong");
    }
  };

  const handleDelete = async (record) => {
    try {
      const res = await axios.delete(
        `${backendUrl}/api/v1/doctor/delete-appointment`,
        {
          data: { appointmentId: record._id }, // Pass appointmentId in the request body
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.success) {
        message.success(res.data.message);
        getAppointments();
      }
    } catch (error) {
      console.log(error);
      message.error("Something Went Wrong");
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "_id",
    },
    {
      title: "Date & Time",
      dataIndex: "date",
      render: (text, record) => (
        <span>
          {moment(record.date).format("DD-MM-YYYY")} &nbsp;
          {moment(record.time).format("HH:mm")}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <div className="d-flex">
          {record.status === "pending" && (
            <div className="d-flex">
              <button
                className="btn btn-success"
                onClick={() => handleStatus(record, "approved")}
              >
                Approve
              </button>
              <button
                className="btn btn-danger ms-2"
                onClick={() => handleStatus(record, "reject")}
              >
                Reject
              </button>
            </div>
          )}
          <Popconfirm
            title="Are you sure you want to delete this appointment?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <button className="btn btn-danger ms-2">Delete</button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <div className="appointments-container">
        <h1 className="appointments-heading">Appointment List</h1>
        <Table
          columns={columns}
          dataSource={appointments}
          pagination={{ pageSize: 5 }}
        />
      </div>
    </Layout>
  );
};

export default DoctorAppointments;
